"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SortDirection = void 0;
// TODO: type properly
let SortDirection = exports.SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection["Ascending"] = "Ascending";
  SortDirection["Descending"] = "Descending";
  SortDirection["None"] = "None";
  return SortDirection;
}({}); // collection.field.active
// collection.field.active
// eslint-disable-next-line @typescript-eslint/no-explicit-any